// Generated by ReScript, PLEASE EDIT WITH CARE


function getContentV1(param) {
  return {
          title_text: "N/A",
          learn_more_text: "N/A",
          info_btn_details: {
            video_url: undefined,
            question: "N/A",
            answer: "N/A"
          },
          learn_more_btn_details: [
            {
              video_url: undefined,
              question: "N/A",
              answer: ""
            },
            {
              video_url: undefined,
              question: "N/A",
              answer: "N/A"
            },
            {
              video_url: undefined,
              question: "N/A",
              answer: "N/A"
            },
            {
              video_url: undefined,
              question: "N/A",
              answer: "N/A"
            },
            {
              video_url: undefined,
              question: "N/A",
              answer: "N/A"
            }
          ],
          locked_score_msg: "N/A",
          message_text: "N/A"
        };
}

function getContentV2(param) {
  return {
          title_text: "N/A",
          learn_more_text: "N/A",
          info_btn_details: {
            video_url: undefined,
            question: "N/A",
            answer: "N/A"
          },
          learn_more_btn_details: [
            {
              video_url: undefined,
              question: "N/A",
              answer: ""
            },
            {
              video_url: undefined,
              question: "N/A",
              answer: "N/A"
            },
            {
              video_url: undefined,
              question: "N/A",
              answer: "N/A"
            },
            {
              video_url: undefined,
              question: "N/A",
              answer: "N/A"
            },
            {
              video_url: undefined,
              question: "N/A",
              answer: "N/A"
            }
          ],
          locked_score_msg: "N/A",
          message_text: "N/A",
          suspension_guide_text: "N/A",
          suspension_guide_table_details: {
            cancellation_score_text: "N/A",
            suspension_days_text: "N/A"
          }
        };
}

export {
  getContentV1 ,
  getContentV2 ,
  
}
/* No side effect */
